import React, { FC } from "react";

interface IProps {
  className?: string;
  onClick?: () => void;
}

export const ArrowRightRoundedIcon: FC<IProps> = ({ className, onClick }) => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M17.94 26.28C17.8133 26.28 17.6867 26.2333 17.5867 26.1333C17.3933 25.94 17.3933 25.62 17.5867 25.4267L21.9333 21.08C22.2533 20.76 22.2533 20.24 21.9333 19.92L17.5867 15.5733C17.3933 15.38 17.3933 15.06 17.5867 14.8667C17.78 14.6733 18.1 14.6733 18.2933 14.8667L22.64 19.2133C22.98 19.5533 23.1733 20.0133 23.1733 20.5C23.1733 20.9867 22.9866 21.4467 22.64 21.7867L18.2933 26.1333C18.1933 26.2267 18.0667 26.28 17.94 26.28Z"
      fill="#59637D"
    />
    <rect x="0.5" y="1" width="39" height="39" rx="19.5" stroke="#BDC5DB" />
  </svg>
);
